const BaseUrl = () => {
    // return" http://localhost:5000/"
    // return"http://52.22.241.165:10027/"
    return "https://live.bsi.one/";
    
};  
export const RedirectUrl = "https://live.bsi.one/serendipity-web/";
// export const RedirectUrl = "http://52.22.241.165:10027/serendipity-web/";

export const BaseUrlFE = "https://live.bsi.one";
// export const BaseUrlFE = "http://52.22.241.165:10027";
// export const BaseUrlFE = "http://localhost:5000";
// export const RedirectUrlLLL = "http://localhost:3000/serendipity-web/";
export default BaseUrl;